export const activityLogFilterValues = [
    'calendarId',
    'startTime',
    'endTime',
    'title',
    'assignedUserId',
    'notes',
    'appoinmentStatus',
    'address',
    'google',
    'outlook',
];
export const activityLogFilterLabels = (t) => {
    return {
        calendarId: t('activity_log.calendar_update'),
        startTime: t('activity_log.start_time_update'),
        endTime: t('activity_log.end_time_update'),
        title: t('activity_log.title_update'),
        notes: t('activity_log.notes_update'),
        appoinmentStatus: t('activity_log.appointment_status_update'),
        address: t('activity_log.meeting_location_update'),
        google: t('activity_log.google_sync_update'),
        outlook: t('activity_log.outlook_sync_update'),
        assignedUserId: t('activity_log.assigned_user_update'),
    };
};
export const getRecurringFrequency = (frequency) => {
    switch (frequency) {
        case 'DAILY':
            return 'Daily';
        case 'WEEKLY':
            return 'Weekly';
        case 'MONTHLY':
            return 'Monthly';
    }
};
export const isMeetingURLValid = (url) => {
    const pattern = new RegExp('^([a-zA-Z]+:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR IP (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$', // fragment locator
    'i');
    // Patterns for meeting URL for zoom / google/ outlook
    const zoomPattern = /zoom.us\//i;
    const googleMeetPattern = /meet.google.com\//i;
    const outlookPattern = /outlook\.office\.com\/(?:[^/]+\/){6}join/i;
    return (pattern.test(url) &&
        (zoomPattern.test(url) ||
            googleMeetPattern.test(url) ||
            outlookPattern.test(url)));
};
export const convertAndFormatSource = (inputString) => {
    if (inputString && (inputString.includes('_') || inputString.includes('-'))) {
        // Choose the separator based on whether underscore or hyphen is present
        const separator = inputString.includes('_') ? '_' : '-';
        // Split the string into words using the chosen separator as separators
        const words = inputString.split(separator);
        // Capitalize the first letter of each word and join them with spaces
        const formattedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
        const formattedString = formattedWords.join(' ');
        return formattedString;
    }
    else {
        return inputString;
    }
};
